import { createKeyFactory } from "@nestoca/utils";

export type Entity =
  | "account"
  | "account-postings-transactions"
  | "application"
  | "assigned-representative"
  | "call-preference"
  | "communication-preference"
  | "component"
  | "conditions"
  | "document"
  | "documentCount"
  | "down-payment"
  | "external-broker"
  | "geolocation"
  | "highlights-result"
  | "insurance-information"
  | "loan"
  | "minimal-components"
  | "paginated-minimal-components"
  | "quotes"
  | "statements";

/**
 * Typed wrapper around @nestoca/utils createKeyFactory, scoped to this
 * project's entities so TypeScript can catch invalid keys at compile time.
 * @see https://github.com/nestoca/fe-shared/blob/master/packages/utils/lib/queries/README.md
 */
export const keyFactory = createKeyFactory<Entity>();
